import React from 'react'

const SingleProj = ({image, title, link, see, linklive}) => {
  return (
    <>
        
        <div className='transform transition-transform duration-300 hover:scale-105 overflow-hidden
                        shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center
                        mx-auto content-div h-[200px] bg-cover relative'>
            <img src={image} alt="proj1" layout='fill' objectFit='cover' className='w-full h-full object-cover'/>
            <div className='opacity-0 group-hover:opacity-90 bg-[lightgray] absolute inset-0 flex-col justify-center items-center'>
                <span className='text-2xl font-bold text-white tracking-wider'></span>
                <div className='pt-8 text-center'>
                    <h2 className='text-2xl font-bold tracking-wider text-gray-700'>{title}</h2>
                    <a href={link} target='_blank' rel='noreferrer'>
                        <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>{see}</button>
                    </a>
                    {linklive && (
                        <a href={linklive} target="_blank" rel="noopener noreferrer">
                            <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>Demo</button>
                        </a>
                    )}
                </div>
            </div>
        </div>

    </>
  )
}

export default SingleProj